// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__13tF2","approved":"Status_approved__2Mno4","rejected":"Status_rejected__1th1u","expired":"Status_expired__Mtwxu","label":"Status_label__2QltZ"};